import { ArrowCircleRightSharp, CheckCircleOutline, PanoramaFishEye } from "@mui/icons-material";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { OrderContext } from "../../../ContextApi/context";
import OrderChkSel from "./OrderChkSel";
import ReactHtmlParser from 'react-html-parser';
import TheMount from "../../../OrderSettings/TheMount";
import TheMoreThenOneMount from "../../../OrderSettings/TheMoreThenOneMount";
import myFunctions from "../../../myFunctions";
import "./ProductComboOptions.css";

const ProductComboOptions = (props) => {

    const [order, setOrder] = useContext(OrderContext);
    const [fullRowtxt, setFullRowtxt] = useState([]);
    const [showMainPopup, setShowMainPopup] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [tempMount, setTempMount] = useState(1);
    const [productOptionsSelections, setProductOptionsSelections] = useState({});
    const [calculatedAddsPrice, setCalculatedAddsPrice] = useState(0);
    const [validationErrors, setValidationErrors] = useState([]);
    const [tempOps, setTempOps] = useState([...props.product.prodOptions]);
    const closedByBackRef = useRef(false);

    // ---- Scroll lock ----

    const unlockScroll = () => {
        const scrollY = -parseInt(document.body.style.top || '0');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
    };

    useEffect(() => {
        if (isPopupOpen) {
            const scrollY = window.scrollY;
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${scrollY}px`;
            return () => unlockScroll();
        }
    }, [isPopupOpen]);

    // ---- Back button interception ----

    useEffect(() => {
        if (showMainPopup) {
            window.history.pushState({ comboPopup: true }, '');

            const handlePopState = () => {
                closedByBackRef.current = true;
                unlockScroll();
                setIsPopupOpen(false);
                setIsClosing(true);

                if (!props.imInOrder) {
                    let cleanOps = JSON.parse(JSON.stringify(props.product.prodOptions));
                    cleanOps.forEach(opt => {
                        opt.selected = Array.isArray(opt.selected) ? [] : 0;
                    });
                    setTempOps(cleanOps);
                    setProductOptionsSelections({});
                }

                setValidationErrors([]);
                setTimeout(() => {
                    setShowMainPopup(false);
                    setIsClosing(false);
                    setTempMount(1);
                }, 500);
            };

            window.addEventListener('popstate', handlePopState);

            return () => {
                window.removeEventListener('popstate', handlePopState);
                if (!closedByBackRef.current) {
                    window.history.back();
                }
                closedByBackRef.current = false;
            };
        }
    }, [showMainPopup]);

    // ---- Initial setup ----

    useEffect(() => {
        if (props.imInOrder) {
            const theord = order.Orders[props.inOrderIndex];
            if (theord != null) getSetedOrder();
        }
        if (props.PopMeUp?.timestamp && props.PopMeUp.timestamp > 0 && tempOps.length !== 0) {
            setIsPopupOpen(true);
            setShowMainPopup(true);
        }
        setSelectionHeader();
    }, []);

    // ---- Popup open trigger ----

    useEffect(() => {
        if (props.PopMeUp?.timestamp && props.PopMeUp.timestamp > 0 && tempOps.length !== 0) {
            if (props.imInOrder) {
                const theord = order.Orders[props.inOrderIndex];
                if (theord != null) getSetedOrder();
            } else {
                let cleanOps = JSON.parse(JSON.stringify(props.product.prodOptions));
                cleanOps.forEach(opt => {
                    opt.selected = Array.isArray(opt.selected) ? [] : 0;
                });
                setTempOps(cleanOps);
                setProductOptionsSelections({});
                setTempMount(1);
            }
            setValidationErrors([]);
            setIsPopupOpen(true);
            setShowMainPopup(true);
        }
    }, [props.PopMeUp]);

    // ---- Update order when selections change ----

    useEffect(() => {
        updateTheOrd();
        setSelectionHeader();
    }, [tempOps]);

    // ---- Refresh header when parent detects item is in-order ----

    useEffect(() => {
        if (props.imInOrder && props.inOrderIndex !== -1) {
            setSelectionHeader();
        }
    }, [props.inOrderIndex, props.imInOrder]);

    // ---- Logic ----

    const getSetedOrder = () => {
        if (!order.Orders[props.inOrderIndex]) return;
        const savedOrder = order.Orders[props.inOrderIndex];
        if (!savedOrder.specials || savedOrder.specials.length === 0) return;

        const newOps = JSON.parse(JSON.stringify(props.product.prodOptions));
        let loadedSelections = {};

        newOps.forEach((ops, count) => {
            savedOrder.specials.forEach(ord => {
                if (ops.optionName === ord.optionName) {
                    newOps[count].selected = ord.spec;
                    ord.spec.forEach((selectedProduct) => {
                        const realProductIndex = ops.options.findIndex(p => p.prodName === selectedProduct.prodName);
                        if (realProductIndex !== -1 && selectedProduct.specials && selectedProduct.specials.length > 0) {
                            const key = `${count}_${realProductIndex}`;
                            loadedSelections[key] = {};
                            selectedProduct.specials.forEach((special) => {
                                const prodOption = ops.options[realProductIndex].prodOptions;
                                if (prodOption) {
                                    const specialIdx = prodOption.findIndex(po => po.optionName === special.optionName);
                                    if (specialIdx !== -1 && special.spec && special.spec.length > 0) {
                                        loadedSelections[key][specialIdx] = special.spec;
                                    }
                                }
                            });
                        }
                    });
                }
            });
        });

        setTempOps(newOps);
        setProductOptionsSelections(loadedSelections);
    };

    const updateTheOrd = () => {
        let orderOptsRows = [];
        tempOps.forEach((el) => {
            if (el.selected !== "" && el.selected != null && el.selected.length > 0) {
                let spec = [];
                el.selected.forEach(elem => {
                    spec.push({
                        prodName: elem.prodName,
                        prodPrice: elem.prodPrice,
                        cashRegMakat: elem.cashRegMakat,
                        specials: elem.specials || [],
                        addToPrice: elem.addToPrice || 0,
                        itmsMount: elem.itmsMount || 1
                    });
                });
                orderOptsRows.push({
                    optionName: el.optionName,
                    spec: spec,
                    nilveMakat: el.nilveMakat,
                });
            }
        });

        let theItm = order.Orders.findIndex(itm => itm.ordProdID === props.itemId);
        let tempAddsPrice = 0;

        orderOptsRows.forEach((item, itemIdx) => {
            const originalOption = tempOps[itemIdx];
            const freeAdds = parseInt(originalOption?.freeAdds || 0);
            if (item.spec && item.spec.length > 0) {
                const getProductPrice = (prod) => parseInt(prod.prodPrice || prod.addToPrice || prod.addsPrice || 0);
                const expandedProducts = [];
                item.spec.forEach(prod => {
                    const mount = prod.itmsMount || 1;
                    for (let i = 0; i < mount; i++) expandedProducts.push(prod);
                });
                const sortedExpanded = [...expandedProducts].sort((a, b) => getProductPrice(b) - getProductPrice(a));
                const productsToCharge = Math.max(0, sortedExpanded.length - freeAdds);
                sortedExpanded.slice(0, productsToCharge).forEach(prod => {
                    tempAddsPrice += getProductPrice(prod);
                });
                item.spec.forEach(prod => {
                    if (prod.specials && prod.specials.length > 0) {
                        prod.specials.forEach(special => {
                            if (special.spec && special.spec.length > 0) {
                                const specialFreeAdds = parseInt(special.freeAdds || 0);
                                const sortedSpecials = [...special.spec].sort((a, b) =>
                                    (parseInt(b.addToPrice || 0) * parseInt(b.itmsMount || 1)) -
                                    (parseInt(a.addToPrice || 0) * parseInt(a.itmsMount || 1))
                                );
                                const specialsToCharge = Math.max(0, sortedSpecials.length - specialFreeAdds);
                                sortedSpecials.slice(0, specialsToCharge).forEach(prc => {
                                    tempAddsPrice += parseInt(prc.addToPrice || 0) * parseInt(prc.itmsMount || 1);
                                });
                            }
                        });
                    }
                });
            }
        });

        if (theItm !== -1) {
            if (showMainPopup || isClosing) {
                order.Orders[theItm].addsPrice = tempAddsPrice;
                order.Orders[theItm].specials = orderOptsRows;
                setOrder({ ...order });
                setCalculatedAddsPrice(tempAddsPrice);
            } else {
                setCalculatedAddsPrice(parseFloat(order.Orders[theItm].addsPrice) || 0);
            }
        } else {
            setCalculatedAddsPrice(tempAddsPrice);
            props.tempOrderProds(orderOptsRows, tempAddsPrice);
        }
    };

    const setSelectionHeader = () => {
        let fROwBk = [];
        if (order.Orders[props.inOrderIndex] != null && order.Orders[props.inOrderIndex].specials) {
            order.Orders[props.inOrderIndex].specials.forEach(ord => {
                if (ord && ord.spec) {
                    fROwBk.push(`<span class="optHeader bold">${ord.optionName || ""}</span><br/>`);
                    ord.spec.forEach(product => {
                        fROwBk.push(`<span class="regular">${product.prodName || ""}</span><br/>`);
                        if (product.specials && product.specials.length > 0) {
                            product.specials.forEach(special => {
                                if (special.spec && special.spec.length > 0) {
                                    fROwBk.push(`<span class="optHeader small comboSubOptLabel">${special.optionName || ""}:</span> `);
                                    special.spec.forEach((item, idx) => {
                                        const separator = idx < special.spec.length - 1 ? ', ' : '';
                                        fROwBk.push(`<span class="regular small">${item.servType || item.prodName || ""}${separator}</span>`);
                                    });
                                    fROwBk.push(`<br/>`);
                                }
                            });
                        }
                    });
                }
            });
            setFullRowtxt(fROwBk);
        }
    };

    const validateMustSelectOptions = () => {
        let errors = [];
        tempOps.forEach((option, index) => {
            if (option.mustSelect) {
                if (!option.selected ||
                    (Array.isArray(option.selected) && option.selected.length === 0) ||
                    option.selected === 0 ||
                    option.selected === "") {
                    errors.push(index);
                }
            }
        });
        return errors;
    };

    const calculateTotalPrice = () => {
        const basePrice = parseFloat(props.product.prodPrice) || 0;
        const mount = props.imInOrder
            ? (order.Orders.find(o => o.ordProdID === props.itemId)?.mount || 1)
            : tempMount;
        return ((basePrice + calculatedAddsPrice) * mount).toFixed(2);
    };

    const buildOrderOptsRows = () => {
        let rows = [];
        tempOps.forEach((el) => {
            if (el.selected !== "" && el.selected != null && el.selected.length > 0) {
                let spec = [];
                el.selected.forEach(elem => {
                    spec.push({
                        prodName: elem.prodName,
                        prodPrice: elem.prodPrice,
                        cashRegMakat: elem.cashRegMakat,
                        specials: elem.specials || [],
                        addToPrice: elem.addToPrice || 0,
                        itmsMount: elem.itmsMount || 1
                    });
                });
                rows.push({ optionName: el.optionName, spec, nilveMakat: el.nilveMakat });
            }
        });
        return rows;
    };

    const closeWithoutAdding = () => {
        unlockScroll();
        setIsPopupOpen(false);
        setIsClosing(true);
        setValidationErrors([]);
        if (!props.imInOrder) {
            let cleanOps = JSON.parse(JSON.stringify(props.product.prodOptions));
            cleanOps.forEach(opt => {
                opt.selected = Array.isArray(opt.selected) ? [] : 0;
            });
            setTempOps(cleanOps);
            setProductOptionsSelections({});
        }
        setTimeout(() => {
            setShowMainPopup(false);
            setIsClosing(false);
            setTempMount(1);
        }, 500);
    };

    //הקומפוננטה הזו תמיד מורכבת לכל מוצר קומבו בתפריט, גם כשהפופאפ שלה סגור -
    //לכן חייבים להתנות ב-isPopupOpen, אחרת עשרות מופעים סגורים נרשמים במחסנית יחד עם הפתוח
    myFunctions.useEscapeKey(isPopupOpen ? closeWithoutAdding : null);

    const closeWithAnimation = () => {
        const errors = validateMustSelectOptions();
        if (errors.length > 0) {
            setValidationErrors(errors);
            setTimeout(() => {
                const errorElement = document.querySelector('.comboSectionTitle.comboSectionError');
                if (errorElement) errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
            return;
        }

        setValidationErrors([]);
        unlockScroll();
        setIsPopupOpen(false);

        if (!props.imInOrder) {
            const orderOptsRows = buildOrderOptsRows();
            if (props.addToOrder) {
                props.addToOrder(orderOptsRows, calculatedAddsPrice, tempMount);
            } else {
                props.tempOrderProds(orderOptsRows, calculatedAddsPrice);
            }
        } else {
            updateTheOrd();
        }

        setIsClosing(true);
        setTimeout(() => {
            setShowMainPopup(false);
            setIsClosing(false);
            setTempMount(1);
        }, 500);
    };

    // ---- Selection handlers ----

    const onProductCheckboxChange = (option, optionIndex, product, productIndex, isChecked) => {
        if (isChecked) {
            toggleProductSelection(option, optionIndex, product, productIndex, []);
        } else {
            let tempOp = [...tempOps];
            if (!tempOp[optionIndex].selected) tempOp[optionIndex].selected = [];
            let currentSelected = [...tempOp[optionIndex].selected];
            const existingIndex = currentSelected.findIndex(sel => sel.prodName === product.prodName);
            if (existingIndex !== -1) currentSelected.splice(existingIndex, 1);
            tempOp[optionIndex].selected = currentSelected;
            setTempOps(tempOp);
        }
        if (isChecked && validationErrors.includes(optionIndex)) {
            setValidationErrors(validationErrors.filter(idx => idx !== optionIndex));
        }
    };

    const onProductOptionSelected = (option, optionIndex, product, productIndex, optionIdx, cheksBack) => {
        const key = `${optionIndex}_${productIndex}`;
        let selections = { ...productOptionsSelections };
        if (!selections[key]) selections[key] = {};
        selections[key][optionIdx] = cheksBack;
        setProductOptionsSelections(selections);

        let specs = [];
        Object.keys(selections[key]).forEach(idx => {
            if (selections[key][idx] && selections[key][idx].length > 0) {
                const prodOption = product.prodOptions[parseInt(idx)];
                specs.push({
                    optionName: prodOption.optionName,
                    freeAdds: prodOption.freeAdds,
                    spec: selections[key][idx],
                    splitSelection: prodOption.splitSelection,
                    nilveMakat: prodOption.nilveMakat,
                });
            }
        });

        toggleProductSelection(option, optionIndex, product, productIndex, specs);
    };

    const updateComboProductMount = (optionIndex, productIndex, newVal) => {
        let tempOp = [...tempOps];
        const productName = tempOp[optionIndex].options[productIndex].prodName;
        const existingIndex = tempOp[optionIndex].selected?.findIndex(sel => sel.prodName === productName);
        if (existingIndex !== -1) {
            tempOp[optionIndex].selected[existingIndex].itmsMount = newVal;
            setTempOps(tempOp);
        }
    };

    const toggleProductSelection = (option, optionIndex, product, productIndex, specs) => {
        let tempOp = [...tempOps];
        if (!tempOp[optionIndex].selected) tempOp[optionIndex].selected = [];
        let currentSelected = [...tempOp[optionIndex].selected];
        const existingIndex = currentSelected.findIndex(sel => sel.prodName === product.prodName);

        if (existingIndex !== -1) {
            if (specs && specs.length > 0) {
                currentSelected[existingIndex].specials = specs;
            } else if (product.prodOptions && product.prodOptions.length > 0) {
                currentSelected[existingIndex].specials = [];
            }
        } else {
            if (!option.allowMulti) currentSelected = [];
            const totalMounts = currentSelected.reduce((sum, sel) => sum + (sel.itmsMount || 1), 0);
            if (option.maxSelection && totalMounts >= parseInt(option.maxSelection)) return;
            currentSelected.push({
                prodName: product.prodName,
                prodPrice: product.prodPrice || 0,
                cashRegMakat: product.cashRegMakat,
                specials: specs || [],
                addToPrice: 0,
                itmsMount: 1
            });
        }

        tempOp[optionIndex].selected = currentSelected;
        setTempOps(tempOp);
    };

    // ---- Render ----

    const renderComboOptions = () => {
        return tempOps.map((option, optionIndex) => {
            if (!option.options || option.options.length === 0) return null;

            const hasError = validationErrors.includes(optionIndex);

            const totalMountsSelected = Array.isArray(option.selected) ? option.selected.reduce((sum, s) => sum + (s.itmsMount || 1), 0) : 0;
            const isMaxReached = option.allowMulti
                ? !!(option.maxSelection && totalMountsSelected >= parseInt(option.maxSelection))
                : totalMountsSelected >= 1;

            const productsInCategory = option.options.map((product, productIndex) => {
                const isSelected = !!(option.selected && option.selected.length > 0 &&
                    option.selected.some(sel => sel.prodName === product.prodName));
                const isDisabled = isMaxReached && !isSelected;

                const selectionControl = (
                    <Checkbox
                        checked={isSelected}
                        disabled={isDisabled}
                        checkedIcon={<CheckCircleOutline />}
                        icon={<PanoramaFishEye />}
                        sx={{ color: "var(--turqiText)", "&.Mui-checked": { color: "var(--turqiText)" } }}
                        onChange={() => !isDisabled && onProductCheckboxChange(option, optionIndex, product, productIndex, !isSelected)}
                    />
                );

                return (
                    <div key={productIndex}>
                        <div className={`comboProductRow${isDisabled ? ' comboProductRowDisabled' : ''}`}>
                            <FormControlLabel
                                control={selectionControl}
                                label={
                                    <div>
                                        <div className={"comboProductRowName"}>{product.prodName}</div>

                                    </div>
                                }
                                className={"FirstFont"}
                                sx={{ fontFamily: "var(--SecondFont)", flex: 1, margin: 0 }}
                                disabled={isDisabled}
                            />
                            <div className={"comboProductRowRight"}>
                                {option.allowMulti && isSelected && (
                                    <div onClick={e => e.stopPropagation()}>
                                        <TheMoreThenOneMount
                                            css={""}
                                            Mount={option.selected?.find(s => s.prodName === product.prodName)?.itmsMount || 1}
                                            minCount={1}
                                            maxSelection={option.maxSelection ? parseInt(option.maxSelection) : 999}
                                            selectedCounting={Array.isArray(option.selected) ? option.selected.reduce((sum, s) => sum + (s.itmsMount || 1), 0) : 0}
                                            clearchkBx={() => onProductCheckboxChange(option, optionIndex, product, productIndex, false)}
                                            changeVal={(newVal) => updateComboProductMount(optionIndex, productIndex, newVal)}
                                        />
                                    </div>
                                )}
                                {product.prodPrice > 0 && (
                                    <div className={"comboProductPrice"}>₪ {product.prodPrice}</div>
                                )}
                            </div>
                        </div>

                        {isSelected && product.prodOptions && product.prodOptions.length > 0 && (
                            <div className={"comboSubOptionsWrap"}>
                                {product.prodProducts && (
                                    <div className={"comboProductRowDesc"}>{product.prodProducts}</div>
                                )}
                                {product.prodOptions.map((prodOption, idx) => {
                                    const key = `${optionIndex}_${productIndex}`;
                                    const existingSelections = productOptionsSelections[key]?.[idx] || [];
                                    const itmWithSelections = { ...prodOption, selected: existingSelections };
                                    return (
                                        <OrderChkSel
                                            key={idx}
                                            itm={itmWithSelections}
                                            indx={idx}
                                            ContCallBack={(cheksBack) => onProductOptionSelected(option, optionIndex, product, productIndex, idx, cheksBack)}
                                        />
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            });

            return (
                <div key={optionIndex} className={"comboOptionSection"}>
                    <div className={`comboSectionTitle${hasError ? ' comboSectionError' : ''}`}>
                        <span>{option.optionName}</span>
                        {option.mustSelect && <span className={"comboRequiredStar"}>*</span>}
                        {option.mustSelect && (!option.selected || option.selected.length === 0) && (
                            <span className={"comboRequiredLabel"}>- בחירה חובה</span>
                        )}
                    </div>
                    <div className={"comboProductsList"}>
                        {productsInCategory}
                    </div>
                </div>
            );
        });
    };

    return (
        <div className={"prodOptions prodComboOptions"}>
            {calculatedAddsPrice > 0 && (
                <div className={"comboAddsPrice"}>+ ₪{calculatedAddsPrice}</div>
            )}

            {(showMainPopup || isClosing) && (
                <div
                    className={`prodOptionsSelect animate__animated ${isClosing ? 'animate__slideOutDown' : 'animate__slideInUp'}`}
                    id={"prodSel"}>
                    <div className={"prodOptionsSelectWrap"}>

                        <div className={"OptionsSelectWrap"}>
                            {props.imgLnk && (
                                <div className={"popupProductImageWrap"}>
                                    <img
                                        src={props.imgLnk}
                                        alt={props.product.prodName}
                                        className={"popupProductImage"}
                                    />
                                    <button type="button" className={"btnReset backSd prodcloseBtn pointing"} aria-label="סגור" onClick={closeWithoutAdding}>
                                        <img src="/PermanentImages/55.png" alt="" aria-hidden="true" />
                                    </button>
                                </div>
                            )}

                            <div className={`headOnOptions bold big${!tempOps || tempOps.length === 0 ? ' noOptionsMode' : ''}`}>
                                {!props.imgLnk && (
                                    <button type="button" className={"btnReset backSd"} aria-label="סגור" onClick={closeWithoutAdding}>
                                        <ArrowCircleRightSharp aria-hidden="true" />
                                    </button>
                                )}
                                <div>{props.product.prodName}</div>
                                {props.product.prodProducts && (
                                    <div className={"mnuDivPrdcReg prodSText noPadding"}>
                                        <div className={"FirstFont inProdTxt smallFont"}>
                                            {props.product.prodProducts}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className={"OptionsSelectTheTops"}>
                                {renderComboOptions()}
                            </div>
                        </div>

                        <div className={"optionsBtnWrapFlout"}>
                            <div className={"selectOpBtnWrap col-12"}>
                                <div className={"bottomMountSection col-4 onRight"}>
                                    {props.imInOrder ? (
                                        <TheMount itemId={props.itemId} remFromOrder={() => props.removeFromOrder()} />
                                    ) : (
                                        <div className={"prodPlusMinus"}>
                                            <div className={"plusBtn"} onClick={() => setTempMount(t => t + 1)}>+</div>
                                            <div className={"mountNum"}>{tempMount}</div>
                                            <div className={"minusBtn"} onClick={() => setTempMount(t => Math.max(1, t - 1))}>-</div>
                                        </div>
                                    )}
                                </div>
                                <div className={"col-7 pointing onLeft"} onClick={closeWithAnimation}>
                                    <div className={"selectOpBtn selectOpBtnSmall col-12"}>
                                        <span className={"onRight spacePadRightVeryBig"}>הוסף להזמנה</span>
                                        <span className={"onLeft spacePadLeftVeryBig"}>{calculateTotalPrice()} ₪</span>
                                    </div>
                                    {validationErrors.length > 0 && (
                                        <div className={"comboValidationError col-12"}>
                                            יש למלא את כל שדות החובה
                                        </div>
                                    )}
                                </div>
                            </div>

                            {props.imInOrder && (
                                <div className={"bottomButtonsRow"}>
                                    <div className={"duplicateButton pointing"} onClick={(e) => {
                                        e.stopPropagation();
                                        closeWithAnimation();
                                        setTimeout(() => props.addDuplicate && props.addDuplicate(), 500);
                                    }}>
                                        נוסף עם שינויים
                                    </div>
                                    <div className={"removeButton pointing"} onClick={(e) => {
                                        e.stopPropagation();
                                        unlockScroll();
                                        setIsPopupOpen(false);
                                        setIsClosing(true);
                                        setTimeout(() => {
                                            props.removeFromOrder && props.removeFromOrder(props.itemId);
                                            setShowMainPopup(false);
                                            setIsClosing(false);
                                        }, 500);
                                    }}>
                                        הסר מההזמנה
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductComboOptions;
